import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pop-chevron',
  templateUrl: './chevron.component.html',
  styleUrls: ['./chevron.component.less']
})
export class ChevronComponent {
  private _isExpanded: boolean | undefined;
  @Input() get isExpanded() {
    return this._isExpanded;
  }
  set isExpanded(value: boolean | undefined) {
    this._isExpanded = value;
    this.isExpandedChange.emit(value);
  }

  @Output() isExpandedChange = new EventEmitter<boolean | undefined>();

  public toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
